import React, { useState, useEffect, useContext } from "react";

import axios from "../../../axios/index";

// Context
import { UserContext } from "../../Context/UserContextProvider";

// custome hooks
import usePriceSeprator from "../../../hooks/usePriceSeparator";

import { Link } from "react-router-dom";

// styles
import styles from "./UserMyAds.module.css";
import Dstyles from "../../Dashboard/DashboardFileManagement/DashboardFileManagement.module.css";

// components
import HomeNavbar from "./../../Home/HomeNavbar/HomeNavbar";
import UserSideDashboard from "../UserSideDashboard/UserSideDashboard";
import Footer from "../../Home/Footer/Footer";
import UserMyAdsCards from "./UserMyAdsCards/UserMyAdsCards";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import CustomPagination from "../../CustomPagination/CustomPagination";

export default function UserMyAds() {
  const { userToken, userData } = useContext(UserContext);
  const [filterCardsByCategory, setFilterCardsByCategory] = useState({
    onSale: true,
    forRent: false,
  });

  const [estatesData, setEstatesData] = useState();
  // const [rentsCard, setRentsCard] = useState()
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState({
    pageNumber: 1,
    pageCount: 5,
  });

  useEffect(() => {
    const dataHandler = async () => {
      // setIsLoading(true)
      const getSalesData = await axios.get(
        `Estate?UserId=${userData.id}&EstateType=${filterCardsByCategory.onSale ? "2" : filterCardsByCategory.forRent && "1"}&Take=6&OrderBy=2`,
        {
          headers: { authorization: "Bearer " + userToken },
        }
      );
      // console.log(simpleUser == "" ? "super" : "normal")
      // console.log(userData.id)
      // console.log(userData.id)
      setPage(prev => {
        return { ...prev, pageNumber: 1, pageCount: getSalesData?.data.data.pageCount };
      });
      const salesData = getSalesData?.data?.data.data || [];
      setEstatesData(salesData);
      // setRentsCard(salesData.filter((item) => item.rentPrice !== 0))

      setIsLoading(false);
    };

    dataHandler();
  }, [userToken, userData.id, filterCardsByCategory.onSale, filterCardsByCategory.forRent]);

  return (
    <>
      {isLoading ? (
        <div className={Dstyles.loader_container}>
          <div className={Dstyles.spinner}></div>
        </div>
      ) : (
        <div className="d-flex justify-content-center align-items-start vw-100 position-relative" dir="rtl">
          <div className="w-100 ms-0 p-0" style={{ background: "#FFFFFF" }}>
            <HomeNavbar />
            <div className="container py-3 px-0 mt-4">
              <div className="w-100 d-flex justify-content-md-between justify-content-center align-items-start">
                <UserSideDashboard myAds />
                <div className={`d-flex flex-column align-items-center justify-content-start p-md-4 p-3 ${styles.main_container}`}>
                  <div className="w-100 d-flex align-items-center justify-content-md-between justify-content-center flex-wrap mb-5">
                    <div className={`my-md-0 my-2 mx-md-0 mx-2 ${styles.title}`}>آگهی‌های من</div>
                    <Link to="/user-add-new-file" className={`mx-md-0 mx-2 ${styles.primary}`}>
                      <svg className="ms-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M7 0.75C7.34518 0.75 7.625 1.02982 7.625 1.375V6.375H12.625C12.9702 6.375 13.25 6.65482 13.25 7C13.25 7.34518 12.9702 7.625 12.625 7.625H7.625V12.625C7.625 12.9702 7.34518 13.25 7 13.25C6.65482 13.25 6.375 12.9702 6.375 12.625V7.625H1.375C1.02982 7.625 0.75 7.34518 0.75 7C0.75 6.65482 1.02982 6.375 1.375 6.375H6.375V1.375C6.375 1.02982 6.65482 0.75 7 0.75Z"
                          fill="#21409A"
                        />
                      </svg>
                      ایجاد آگهی
                    </Link>
                  </div>

                  <div className="w-100 d-flex align-items-center justify-content-start mb-4">
                    <div className={`d-flex align-items-center justify-content-between ${styles.filter_btns_right_container}`}>
                      <div
                        className={filterCardsByCategory.onSale ? styles.selected_card_category : styles.unselected_card_category}
                        onClick={cardHandler}
                        id="onSale"
                        style={filterCardsByCategory.onSale ? { marginRight: ".25rem" } : { marginRight: "1.5rem" }}>
                        فروش
                      </div>
                      <div
                        className={filterCardsByCategory.forRent ? styles.selected_card_category : styles.unselected_card_category}
                        onClick={cardHandler}
                        id="forRent"
                        style={filterCardsByCategory.forRent ? { marginLeft: "0.25rem" } : { marginLeft: "1.5rem" }}>
                        رهن و اجاره
                      </div>
                    </div>
                  </div>

                  <UserMyAdsCards cardData={estatesData} usePriceSeprator={usePriceSeprator} filterCardsByCategory={filterCardsByCategory} myFiles myAds />

                  <Stack
                    className={Dstyles.pagination}
                    spacing={1}
                    sx={{
                      direction: "ltr",
                      bottom: "0",
                      height: "85px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center !important",
                    }}>
                    {/* <Typography>Page: {page}</Typography> */}
                    <CustomPagination count={page.pageCount} variant="outlined" shape="rounded" page={page.pageNumber} onChange={paginationHandler} />
                  </Stack>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      )}
    </>
  );

  function cardHandler(event) {
    if (event.target.id === "onSale") {
      setFilterCardsByCategory(prev => {
        return { ...prev, onSale: true, forRent: false };
      });
    } else if (event.target.id === "forRent") {
      setFilterCardsByCategory(prev => {
        return { ...prev, forRent: true, onSale: false };
      });
    }
  }

  async function paginationHandler(event, value) {
    setIsLoading(true);
    const getSalesData = await axios.get(
      `Estate?UserId=${userData.id}&PageId=${value}&EstateType=${filterCardsByCategory.onSale ? "2" : filterCardsByCategory.forRent && "1"}&Take=6&OrderBy=2`
    );
    const salesData = getSalesData.data.data.data;
    setPage(prev => {
      return { ...prev, pageCount: getSalesData.data.data.pageCount, pageNumber: value };
    });
    setEstatesData(salesData);
    setIsLoading(false);
  }
}
